import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCheck } from '@fortawesome/free-solid-svg-icons'
import { adresKartyKlienta, nazwaZestawuKlienta, zapiszIPrzypisz } from '../../lib/klienci/asystentKlienta'

/**
 * Główny przycisk karty wariantu w trybie „dla klienta” (2026-10-11): zapis na koncie, podpięcie pod klienta
 * i powrót do jego karty, gdzie zestaw widać w kafelku „Zestaw”. Zastępuje przejście do wyboru wykonawcy,
 * bo firma dobiera tu sprzęt dla swojego klienta, a nie szuka instalatora.
 *
 * Podwójne kliknięcie nie zapisze dwóch zestawów: blokada w refie działa od razu, zanim React przerysuje
 * przycisk jako wyłączony. Gdy zapis się udał, a podpięcie nie, ponowienie tylko podpina ten sam zestaw.
 */
const ZapiszDlaKlienta = ({ klient, variant, requestPayload, nazwaWstepna = '' }) => {
  const navigate = useNavigate()
  const [stan, setStan] = useState('idle') // idle | busy | done
  const [blad, setBlad] = useState('')
  const trwa = useRef(false)
  const zapisany = useRef(null)

  const zapisz = async () => {
    if (trwa.current) return
    trwa.current = true
    setStan('busy')
    setBlad('')
    const wynik = await zapiszIPrzypisz({
      variant,
      requestPayload,
      nazwa: nazwaZestawuKlienta(nazwaWstepna, klient.nazwa, variant),
      klientId: klient.id,
      zapisanyId: zapisany.current,
    })
    zapisany.current = wynik.kitId
    if (!wynik.ok) {
      trwa.current = false
      setStan('idle')
      setBlad(wynik.error)
      return
    }
    // Blokada zostaje: strona za chwilę przechodzi do karty klienta.
    setStan('done')
    navigate(adresKartyKlienta(klient.id))
  }

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={zapisz}
        disabled={stan !== 'idle'}
        className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-blue-600
                   text-white font-semibold hover:bg-blue-500 active:bg-blue-700 transition-colors
                   disabled:bg-blue-400 disabled:cursor-wait"
      >
        <FontAwesomeIcon icon={faUserCheck} />
        {stan === 'busy' ? 'Zapisuję…' : stan === 'done' ? 'Zapisano, wracam do klienta…' : 'Zapisz i przypisz do klienta'}
      </button>
      <p className="mt-1.5 text-center text-[11px] text-gray-500">
        Zestaw trafi do karty klienta: {klient.nazwa}
      </p>
      {blad && <p role="alert" className="mt-1.5 text-xs text-red-600">{blad}</p>}
    </div>
  )
}

export default ZapiszDlaKlienta
